import ReactGA from "react-ga4";

const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

const isEnabled = Boolean(GA_MEASUREMENT_ID);

if (isEnabled) {
  ReactGA.initialize(GA_MEASUREMENT_ID);
}

export const trackPageView = () => {
  if (!isEnabled) return;
  ReactGA.send({
    hitType: "pageview",
    page: window.location.pathname + window.location.search,
  });
};

export const trackEvent = (category, action, label = "", value = null) => {
  if (!isEnabled) return;
  ReactGA.event({
    category,
    action,
    label,
    value,
  });
};

export const getTenantName = () => {
  const hostname = window.location.hostname;
  if (!hostname || hostname === "localhost") {
    return "local";
  }
  return hostname.split(".")[0] || "unknown";
};
